export default "/assets/f2808aa21587f386.svg"